var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"pill":_vm.pill,"variant":_vm.variant}},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_c('span',[_vm._v("Unknown")])])
}
var staticRenderFns = []

export { render, staticRenderFns }